import React from 'react'
import { Link } from 'react-router-dom'

const sections = [
  {
    title: '1. Introduction',
    paragraphs: [
      'This Cookie Policy explains how Medpool uses cookies and similar tracking technologies on our website, dashboards, and mobile experiences.',
      'By continuing to browse or use our Services, you agree that we can store and access cookies as described below.'
    ]
  },
  {
    title: '2. What Are Cookies?',
    paragraphs: [
      'Cookies are small text files stored on your device when you visit a website. They help remember preferences, keep you signed in, and measure how the site is used.',
      'We also employ web beacons, pixels, and local storage technologies that perform similar functions.'
    ]
  },
  {
    title: '3. Types of Cookies We Use',
    paragraphs: [
      'Essential Cookies: Required for core features like authentication, session management, and security.',
      'Performance Cookies: Help us understand how visitors interact with pages so we can improve load times and usability.',
      'Functionality Cookies: Remember your preferences (state selections, saved filters, language) to provide a customized experience.',
      'Advertising & Analytics Cookies: Used rarely on Medpool; when enabled, they help measure campaign performance and display relevant content.'
    ]
  },
  {
    title: '4. Third-Party Cookies',
    paragraphs: [
      'Some cookies are set by trusted partners that provide analytics, payment processing, or infrastructure services. These partners are contractually required to protect your data and use it only for the agreed purpose.'
    ]
  },
  {
    title: '5. Managing Cookies',
    paragraphs: [
      'Most browsers allow you to manage cookies through settings where you can block or delete them.',
      'Disabling essential cookies may impact your ability to log in or use key platform features. For the best experience, keep essential cookies enabled.'
    ]
  },
  {
    title: '6. Do Not Track Signals',
    paragraphs: [
      'Currently, we do not respond to “Do Not Track” signals because there is no industry standard for compliance. We will revisit this as standards evolve.'
    ]
  },
  {
    title: '7. Updates to This Policy',
    paragraphs: [
      'We may revise this Cookie Policy from time to time. Changes will be posted on this page with an updated effective date.'
    ]
  },
  {
    title: '8. Contact Us',
    paragraphs: [
      'Questions about our use of cookies can be sent to privacy@medpool.health or addressed to Medpool HQ, 42 Healthcare Drive, Lagos, Nigeria.'
    ]
  }
]

const CookiePolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-10">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900">
            <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </Link>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-lg">
          <div className="mb-10 text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-gray-100 px-4 py-1 text-xs font-semibold text-gray-600">
              Updated {new Date().toLocaleDateString()}
            </div>
            <h1 className="mt-4 text-3xl font-bold text-gray-900">Medpool Cookie Policy</h1>
            <p className="mt-3 text-base text-gray-600">
              Learn how and why we use cookies, plus the choices available to you.
            </p>
          </div>

          <div className="space-y-8">
            {sections.map(section => (
              <section key={section.title}>
                <h2 className="text-xl font-semibold text-gray-900">{section.title}</h2>
                <div className="mt-3 space-y-3 text-sm text-gray-700 leading-relaxed">
                  {section.paragraphs.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-10 rounded-xl bg-gray-50 p-6 text-sm text-gray-700">
            <h3 className="mb-2 font-semibold text-gray-900">Need more details?</h3>
            <p>
              Email{' '}
              <a href="mailto:privacy@medpool.health" className="text-blue-600 hover:underline">privacy@medpool.health</a>{' '}
              and we’ll be happy to help.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy


